import {ViewType} from "../../../gd/const/views/view-type"
import ViewMyAttendance from "../../../model2/custom-view/views/my-attendance"

// Should run
// 1. all data loaded we are ready to show GD interface ...
// 2. on CompanyUser change - ?
// 3. on module on / off
// 4. custom-view -> reset session event (happens on view add)

const debug = false
// const debug = "moduleClockInOut_initCustomView"

export default function moduleClockInOut_initCustomView() {
    if (!gd.modules) return

    const isAttendanceViewRequired  = gd.modules.clockInOut.enabled && gd.session.companyUsers.getByUserId(gd.user.id)?.clockInOutEnabled
    const attendanceView            = gd.session.customViews.getByViewType(ViewType.MY_ATTENDANCE)[0] as ViewMyAttendance

    debug && console.trace(debug, 'process', isAttendanceViewRequired, attendanceView)

    //if attendance view is required and no attendance view them add dynamic one
    if (isAttendanceViewRequired && !attendanceView) {
        const view = new ViewMyAttendance()
        gd.session.customViews.add(view)
        view.addNavigationSortPosition()
    }

    //if attendance view is NOT required but dynamic attendance view is added then remove it
    if (!isAttendanceViewRequired && attendanceView?.isDynamic) {
        attendanceView.removeFromNavigationSortPosition()
        gd.session.customViews.remove(attendanceView.id)
    }
}